import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { EstadoInfoFiviI } from 'src/app/modelos/EstadoInformacionFivi';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { NovedadI } from 'src/app/modelos/Novedad';
import { UsuarioI } from 'src/app/modelos/usuario.interface';
import { ApiService } from 'src/app/servicios/api/api.service';
import { NovedadesService } from 'src/app/servicios/novedades/novedades.service';

@Component({
  selector: 'app-novedades',
  templateUrl: './novedades.component.html',
  styleUrls: ['./novedades.component.css']
})
export class NovedadesComponent implements OnInit {

  fechaActual : Date;
  fechaMostrar : string;
  nombreUsuario : String;
  UsuarioFuente : UsuarioI;
  fuenteUsuario : fuenteI;
  NuevaNovedad : NovedadI;
  EstadoInfomacionFuente : EstadoInfoChvI = new EstadoInfoChvI;
  EstadoInfomacionFuenteFivi : EstadoInfoFiviI = new EstadoInfoFiviI;
  TipoFuente : Boolean = true;
  valiTipoNov : Boolean;

  btnGuardar : Boolean;


  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService,
    private novedades: NovedadesService
  ) { }

  ngOnInit(): void {
    let date = new Date();
    this.fechaActual = date;
    this.fechaMostrar = date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear();
    this.btnGuardar = false;
    this.NuevaNovedad = new NovedadI;
    this.NuevaNovedad.tipoNov = "";
    this.NuevaNovedad.fechaNov = date.getDate() + '/' + (date.getMonth()+1) + '/' + date.getFullYear();
    this.NuevaNovedad.justNov = "";
    this.valiTipoNov = false;
    this.nombreUsuario = localStorage.getItem('usuario');
    this.api.getUsuarioByUsername(this.nombreUsuario).subscribe(Usuario=>{
      this.UsuarioFuente = Usuario;
      this.NuevaNovedad.idUsuario = Usuario.id;
      this.api.getFuenteById(Usuario.fuente).subscribe(Fuente=>{
        this.fuenteUsuario = Fuente;
        this.NuevaNovedad.idFte = Fuente.id;
      });
    });
    if (localStorage.getItem('tipo') == "CHV"){
      this.TipoFuente = true;
      this.api.ConsultarEstadoInfoPorId(localStorage.getItem('idEstInfFte')).subscribe(data=>{
        this.EstadoInfomacionFuente = data;
        this.NuevaNovedad.idPerido = data.idperiodo.id;
        if(data.estado =='Cargado' || data.estado =='Aprobado') {
          this.consultarNovedadReportada(data.idperiodo.id, data.fuente.id);
        }
      });
    } else if (localStorage.getItem('tipo') == "FIVI") {
      this.TipoFuente = false;
      this.api.ConsultarEstadoInfoFiviPorId(localStorage.getItem('idEstInfFte')).subscribe(data=>{
        this.EstadoInfomacionFuenteFivi = data;
        this.NuevaNovedad.idPerido = data.idPeriodo.id;
        if(data.estado =='Cargado' || data.estado =='Aprobado') {
          this.consultarNovedadReportada(data.idPeriodo.id, data.idFuente.id);
        }
      });
    }
  }

  consultarNovedadReportada(idPeriodo, idFuente){
    this.novedades.consultarNovedadReportada(idPeriodo, idFuente).subscribe(result=>{
      if(result != false){
        this.NuevaNovedad.tipoNov = result.tipoNov;
        this.fechaMostrar = result.fechaNov;
        this.NuevaNovedad.justNov = result.justNov;
        this.btnGuardar = true;
      } else {
        this.btnGuardar = false;
      }
    });
  }

  validarTipoNov(valor){
    console.log(valor);
    if(valor == "" || valor == null){
      this.valiTipoNov = true;
    }
    if(valor != ""){
      this.valiTipoNov = false;
    }
  }

  GuardarNovedadChv(){
    this.btnGuardar = true;
    this.EstadoInfomacionFuente.estado = "Cargado";
    this.EstadoInfomacionFuente.novedadSis = "99 - Rinde / Novedad reportada"
    this.EstadoInfomacionFuente.novedadUsu = this.NuevaNovedad.tipoNov;
    this.EstadoInfomacionFuente.observacionFte = this.NuevaNovedad.justNov;
    if(this.valiTipoNov || this.NuevaNovedad.tipoNov == ""){
      this.toastr.warning('Debe seleccionar el tipo de novedad.','Advertencia!');
      this.btnGuardar = false;
    }else if(this.NuevaNovedad.justNov.length <= 0){
      this.toastr.warning('Debe ingresar la justificación.','Advertencia!');
      this.btnGuardar = false;
    }else if(this.NuevaNovedad.justNov.length <= 20){
      this.toastr.warning('Justificaión muy corta.','Advertencia!');
      this.btnGuardar = false;
    } else {
      //console.log(this.NuevaNovedad);
      //console.log(this.EstadoInfomacionFuente);
      this.api.nuevoNovedadFuente(this.NuevaNovedad).subscribe(Result=>{
        if(Result){
          this.api.GuardarEstadoInformacionChv(this.EstadoInfomacionFuente).subscribe(Result1=>{
            if(Result1){
              this.toastr.success('Novedad guardada.','OK!');
            }
          });
        }
      }, error=> {
        this.btnGuardar = false;
        this.toastr.error('Error al guardar novedad.','error!');
      });

    }
  }

  GuardarNovedadFivi(){
    this.btnGuardar = true;
    this.EstadoInfomacionFuenteFivi.estado = "Cargado";
    this.EstadoInfomacionFuenteFivi.novedadSis = "99 - Rinde / Novedad reportada"
    this.EstadoInfomacionFuenteFivi.novedadUsu = this.NuevaNovedad.tipoNov;
    this.EstadoInfomacionFuenteFivi.observacionFte = this.NuevaNovedad.justNov;
    if(this.valiTipoNov || this.NuevaNovedad.tipoNov == ""){
      this.toastr.warning('Debe seleccionar el tipo de novedad.','Advertencia!');
      this.btnGuardar = false;
    }else if(this.NuevaNovedad.justNov.length <= 0){
      this.toastr.warning('Debe ingresar la justifiación.','Advertencia!');
      this.btnGuardar = false;
    }else if(this.NuevaNovedad.justNov.length <= 20){
      this.toastr.warning('Justificaión muy corta.','Advertencia!');
      this.btnGuardar = false;
    } else {
      this.api.nuevoNovedadFuente(this.NuevaNovedad).subscribe(Result=>{
        if(Result){
          this.api.GuardarEstadoInformacionFivi(this.EstadoInfomacionFuenteFivi).subscribe(Result2=>{
            if(Result2){
              this.toastr.success('Novedad guardada.','OK!');
            }
          });
        }
      }, error=> {
        this.btnGuardar = false;
        this.toastr.error('Error al guardar novedad.','error!');
      });

    }
  }

}
